var KBDidYouMean = React.createClass({
  propTypes: {
    didYouMean: React.PropTypes.string
  },
  submitDidYouMeanSearch() {
    RA.SearchBar.setSearchText(this.props.didYouMean);

	let searchForm = $(".main-search__form");
	searchForm.submit();
  },
  render() {
    if (this.props.didYouMean === '' || !RA.KBSearch.showDidYouMean) {
      return <span />
    }

    return (
		<div className="kbDidYouMean">
			{Labels.getLabel("Did You Mean")}:&nbsp;
			<a href="#" className="text-muted" onClick={this.submitDidYouMeanSearch}>
				{this.props.didYouMean}
			</a>
		</div>
    );
  }
});


